import { render } from "./ProviderQuestionReview.vue?vue&type=template&id=6c2abe91&scoped=true"
import script from "./ProviderQuestionReview.vue?vue&type=script&lang=js"
export * from "./ProviderQuestionReview.vue?vue&type=script&lang=js"

import "./ProviderQuestionReview.vue?vue&type=style&index=0&id=6c2abe91&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2abe91"]])

export default __exports__